<div class="dialog-wrapper">

  <h1 mat-dialog-title class="dialog-title">Koppla maskiner till maskinlag {{data.team.teamId}}</h1>

  <div class="dialog-header">
    <mat-form-field appearance="outline" class="search-filter">
      <mat-label>Sök</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Skriv för att filtrera" class="search-input">
      <mat-icon matSuffix>search</mat-icon>

    </mat-form-field>

    <mat-checkbox (change)="onChangeShowDeactivatedMachines($event.checked)" class="dialog-header-checkbox">
      <mat-label>Visa inaktiva</mat-label>
    </mat-checkbox>
  </div>

  <mat-dialog-content>
    <div class="machine-info-container">

      <table mat-table [dataSource]="machinesDataSource" class="mat-elevation-z8 machine-table">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="machineIsAdded(element)" [disabled]="machineIsAdded(element)"
              (change)="onCheckboxChange(element, $event)" class="column-checkbox">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="machineId">
          <th mat-header-cell *matHeaderCellDef>Maskinnr</th>
          <td mat-cell *matCellDef="let element"> {{ element.machineId }} </td>
        </ng-container>

        <ng-container matColumnDef="machineTypeText">
          <th mat-header-cell *matHeaderCellDef>Maskintyp</th>
          <td mat-cell *matCellDef="let element">{{ element.baseInfo.machineTypeText }}</td>
        </ng-container>


        <ng-container matColumnDef="ownerText">
          <th mat-header-cell *matHeaderCellDef>Entreprenör</th>
          <td mat-cell *matCellDef="let element">{{ element.baseInfo.ownerText }}</td>
        </ng-container>

        <ng-container matColumnDef="statusText">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.baseInfo.machineStatusText }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
      </table>

    </div>

  </mat-dialog-content>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button (click)="onCancel()">Avbryt</button>

    <button mat-raised-button color="primary" (click)="onConfirm()" cdkFocusInitial
      [disabled]="addedMachines.length === 0">
      Koppla {{addedMachines.length ? addedMachines.length : ''}} {{addedMachines.length === 1 ? 'maskin' :
      'maskiner'}}</button>
  </div>

</div>